import { Tag } from "antd";
import { WaterInvoiceStatus } from "../enums/global.enums";
import { CSSProperties } from "react";

export function invoiceStatusPipe(value: string) {
    switch (value) {
        case WaterInvoiceStatus.All: return "Tất cả";
        case WaterInvoiceStatus.Canceled: return "Đã huỷ";
        case WaterInvoiceStatus.Paid: return "Đã thanh toán";
        case WaterInvoiceStatus.Unpaid: return "Chưa thanh toán";
    }
    return "Chưa thanh toán";
}

export function invoiceStatusTagsPipe(value: string) {
    const style: CSSProperties = {
        width: "100%",
        minWidth: "100px",
        textAlign: "center",
        margin: "0px",
    }
    switch (value) {
        case WaterInvoiceStatus.All: return <Tag color={"var(--primary-button)"} style={style}><b>Tất cả</b></Tag>;
        case WaterInvoiceStatus.Canceled: return <Tag color={"var(--disabled-button)"} style={style}><b>Đã huỷ</b></Tag>;
        case WaterInvoiceStatus.Paid: return <Tag color={"var(--success-button)"} style={style}><b>Đã thanh toán</b></Tag>;
        case WaterInvoiceStatus.Unpaid: return <Tag color={"var(--danger-button)"} style={style}><b>Chưa thanh toán</b></Tag>;
    }
}